<template>
  <div class="ptselector text-xs-center">
    <v-bottom-sheet v-model="sheet" inset>
      <v-tabs
    dark
    color="cyan"
    show-arrows
    v-if='patients.length>0'
  >
    <v-tabs-slider color="yellow"></v-tabs-slider>
      <v-tab
         v-for="n in patientCount"
         :key="n-1"
         ripple
       >
         Patient {{ n }}
       </v-tab>
       <v-tab-item
         v-for="(pt,index) in patients"
         :key="index"
       >
         <v-card>
           <v-card-title>
             <v-layout row wrap>
               <v-flex xs4>
                 <span class='headline text-uppercase'>{{ pt.patient.id }}</span><br>
                 <br>
                 <span class='title'>{{pt.patient.features.age}} yrs, {{pt.patient.features.race}}, {{pt.patient.features.gender}} </span>
               </v-flex>
               <v-flex xs8 class='ptfeature'>
                 <v-flex v-for='(value,key) in pt.patient.features' :key='key'>
                  <span class='title font-weight-regular font-italic' v-if='entrydisplay(key, value).display'>{{entrydisplay(key,value).text}}</span></v-flex>
               </v-flex>
             </v-layout>
        </v-card-title>
        <v-card-actions>
          <!-- <v-btn flat color="orange">Cancel</v-btn> -->
            <v-spacer></v-spacer>
          <v-btn flat color="orange" @click='selectPt(index)'>Select</v-btn>
        </v-card-actions>

         </v-card>
       </v-tab-item>
  </v-tabs>

    </v-bottom-sheet>
  </div>
</template>
<script>
  export default {
    data: () => ({
      sheet: false,
      text: 'Lorem ipsum dolor sit amet, lamco laboris nisi ut aliquip ex ea commodo consequat.'
    }),
    mounted: function(){
      var self = this;
      this.$bus.$on('openselector',(bool)=>{self.sheet=bool})
    },
    watch:{
      sheet:function(){
        if(!this.sheet){
          this.$emit('hideselector')
        }
      }
    },
    computed: {
      patients: function(){
        var pts = this.$store.getters.getPatientData
        return pts
      },
      featureSamplePanel:function(){
        return this.$store.getters.getFeatureSamplePanel
      },
      patientCount: function(){
        return this.patients.length
      }
    },
    methods: {
      selectPt:function(index){
        this.$bus.$emit('selectPatient',index)
        this.$store.commit('setCurrentPatientIndex', index)
        this.sheet = false
      },
      entrydisplay:function(key, value){
        var obj = {}
        var idx = this.featureSamplePanel.patient.features.findIndex(function(e){
          return e.name==key
        })
        // console.log(idx+": "+key+"=>"+value)
        if(idx!=-1){
          if(this.featureSamplePanel.patient.features[idx].group=='demographics'){
            obj.display=false;
            obj.text=''
          } else if(this.featureSamplePanel.patient.features[idx].type=='boolean'){
            obj.display=value
            obj.text=this.featureSamplePanel.patient.features[idx].label
          } else if(this.featureSamplePanel.patient.features[idx].type=='number') {
            obj.display=true
            obj.text=this.featureSamplePanel.patient.features[idx].label+": "+value+" "+this.featureSamplePanel.patient.features[idx].unit
          }
        }
        // console.log(obj)
        return obj
      }
    }
  }
</script>
<style scoped>
.v-tabs {
    background-color: #fff;
    padding-top: 2px;
    padding-bottom: 2px;
    max-height: 460px;
    min-height: 360px;
    overflow-y: auto;
}
.v-list__tile:not(.v-list__tile--avatar) {
    height: 16px;
}
.v-list__tile__title {
    height: 16px;
    line-height: 16px;
    position: relative;
    text-align: left;
}
.ptfeature {
  height: 240px;
  overflow-y: auto;
}
</style>
